import { useState } from 'react';
import { CompetitionClassClient, CompetitionClassDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useCompetitionClassApi = () => {
    const apiClient = new CompetitionClassClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: CompetitionClassDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createCompetitionClass(data);
        } catch (err: any) {
            setError(err.message || 'Error creating CompetitionClass');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: CompetitionClassDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateCompetitionClass(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating CompetitionClass');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getCompetitionClassById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching CompetitionClass');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchCompetitionClasses(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching CompetitionClasses');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteCompetitionClass(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting CompetitionClass');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};